import { NativeEventBus } from '../native/NativeEventBus';
import { TrackingEvent } from './types';

export const trackEvent = <T extends TrackingEvent>(eventData: T): void => {
  if (NativeEventBus.isNativeBridgeAvailable()) {
    new NativeEventBus().trackEvent(eventData);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
};
